"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TableHeader = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var types = _interopRequireWildcard(require("../../constants"));

var _material = require("@mui/material");

var _helper = require("../../helper");

require("./styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TableHeader = /*#__PURE__*/function (_Component) {
  _inherits(TableHeader, _Component);

  var _super = _createSuper(TableHeader);

  function TableHeader() {
    var _this;

    _classCallCheck(this, TableHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onSortColumn", function (column) {
      var _this$props = _this.props,
          tableActions = _this$props.tableActions,
          _this$props$tableData = _this$props.tableData,
          columns = _this$props$tableData.columns,
          idKey = _this$props$tableData.idKey,
          selectEnabled = _this$props$tableData.selectEnabled,
          _this$props$tableData2 = _this$props$tableData.tableSettings,
          searchTerm = _this$props$tableData2.searchTerm,
          sortColumn = _this$props$tableData2.sortColumn,
          selectedRows = _this$props$tableData2.selectedRows,
          sortDirection = _this$props$tableData2.sortDirection;
      var rowData = tableActions.getFormattedRowData(selectedRows); // use original table data

      var nextSortDirection = types.ASCENDING;

      if (column.key === sortColumn) {
        switch (sortDirection) {
          case types.ASCENDING:
            nextSortDirection = types.DESCENDING;
            break;

          case types.DESCENDING:
            nextSortDirection = null;
            break;

          default:
            nextSortDirection = types.ASCENDING;
            break;
        }
      }

      var updatedRowData = searchTerm ? (0, _helper.dataSort)(nextSortDirection, column, (0, _helper.dataFilter)(rowData, tableActions.getVisibleColumns(columns), idKey, searchTerm)) : (0, _helper.dataSort)(nextSortDirection, column, rowData);

      var tableSettings = _objectSpread(_objectSpread({}, _this.props.tableData.tableSettings), {}, {
        sortColumn: nextSortDirection ? column.key : '',
        sortDirection: nextSortDirection,
        pageIndex: 0
      });

      var updatedState = {
        rowData: updatedRowData,
        tableSettings: tableSettings
      };

      if (selectEnabled) {
        updatedState.selectedRows = updatedRowData.filter(function (row) {
          return row.selected;
        });
      }

      _this.props.tableActions.updateTableState(updatedState);
    });

    return _this;
  }

  _createClass(TableHeader, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          customSortedIcon = _this$props2.customSortedIcon,
          loading = _this$props2.loading,
          stickyHeader = _this$props2.stickyHeader,
          tableActions = _this$props2.tableActions,
          _this$props2$tableDat = _this$props2.tableData,
          bulkActions = _this$props2$tableDat.bulkActions,
          bulkStatusChange = _this$props2$tableDat.bulkStatusChange,
          columns = _this$props2$tableDat.columns,
          selectEnabled = _this$props2$tableDat.selectEnabled,
          rowData = _this$props2$tableDat.rowData,
          _this$props2$tableDat2 = _this$props2$tableDat.tableSettings,
          selectedRows = _this$props2$tableDat2.selectedRows,
          sortColumn = _this$props2$tableDat2.sortColumn,
          sortDirection = _this$props2$tableDat2.sortDirection;
      var showHeaderCheckbox = !bulkStatusChange && bulkActions.length === 0; // only show if bulk options are not being used in TableToolbar

      var headerRowColumns = tableActions.getVisibleColumns(columns).map(function (column) {
        var stickyHeaderClass = stickyHeader ? 'TableHeader_stickyHeader' : '';
        var statusOptionsClass = column.statusOptions !== undefined ? 'SmartTable_statusOption' : '';
        var sortedIcon = customSortedIcon ? customSortedIcon : /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            display: 'flex'
          }
        }, /*#__PURE__*/_react["default"].createElement(_material.Icon, {
          style: {
            fontSize: '18px'
          }
        }, sortDirection === types.ASCENDING ? 'arrow_drop_down' : 'arrow_drop_up')); // eslint-disable-next-line array-callback-return

        if (!column.show) return; // if column.show is false, do not load the column

        return /*#__PURE__*/_react["default"].createElement("th", {
          key: column.key,
          className: "".concat(stickyHeaderClass, " ").concat(statusOptionsClass),
          style: _objectSpread({}, column.customStyle)
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "TableHeader_headerCell",
          onClick: function onClick() {
            return _this2.onSortColumn(column);
          }
        }, /*#__PURE__*/_react["default"].createElement("span", {
          style: column.type === types.CURRENCY ? {
            width: '100%',
            textAlign: 'right'
          } : {}
        }, column.title), sortColumn === column.key ? sortedIcon : null));
      });
      this.props.tableActions.actionsByTypeGet(types.ROW_BUTTON).forEach(function (button, index) {
        headerRowColumns.push( /*#__PURE__*/_react["default"].createElement("th", {
          key: "rowButtonColumn_".concat(button.label).concat(index),
          className: "SmartTable_buttonColumn ".concat(stickyHeader ? 'TableHeader_stickyHeader' : '')
        }, button.displayName ? button.displayName : ''));
      });
      this.props.tableActions.actionsByTypeGet(types.ROW_ICON).forEach(function (iconAction, index) {
        headerRowColumns.push( /*#__PURE__*/_react["default"].createElement("th", {
          key: "rowIconColumn_".concat(iconAction.icon).concat(index),
          className: "SmartTable_iconColumn ".concat(stickyHeader ? 'TableHeader_stickyHeader' : '')
        }, iconAction.displayName ? iconAction.displayName : ''));
      });

      if (this.props.tableActions.actionsByTypeGet(types.ROW_MENU).length > 0) {
        headerRowColumns.push( /*#__PURE__*/_react["default"].createElement("th", {
          key: "rowMenuColumn",
          className: "SmartTable_iconColumn ".concat(stickyHeader ? 'TableHeader_stickyHeader' : '')
        }));
      }

      if (selectEnabled) {
        var column = {
          key: 'selected',
          type: types.BOOLEAN
        };
        headerRowColumns.unshift( /*#__PURE__*/_react["default"].createElement("th", {
          key: "select",
          className: stickyHeader ? 'TableHeader_stickyHeader SmartTable_selectColumn' : 'SmartTable_selectColumn'
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "TableHeader_checkbox"
        }, showHeaderCheckbox && /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
          checked: rowData.length > 0 && rowData.length === selectedRows.length,
          onChange: function onChange(e, checked) {
            return _this2.props.tableActions.selectAllRowsHandle(checked);
          },
          indeterminate: selectedRows.length > 0 && selectedRows.length < rowData.length,
          style: {
            marginLeft: '14px'
          },
          disabled: loading
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: "TableHeader_headerCell",
          onClick: function onClick() {
            return _this2.onSortColumn(column);
          },
          style: {
            margin: 'auto',
            width: '100%',
            justifyContent: 'center',
            marginLeft: showHeaderCheckbox ? '-20px' : 'auto'
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            display: 'flex',
            visibility: sortColumn === column.key ? 'visible' : 'hidden'
          }
        }, /*#__PURE__*/_react["default"].createElement(_material.Icon, {
          style: {
            fontSize: '18px'
          }
        }, sortColumn === column.key && sortDirection === types.ASCENDING ? 'arrow_drop_down' : 'arrow_drop_up'))))));
      }

      return /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", null, headerRowColumns));
    }
  }]);

  return TableHeader;
}(_react.Component);

exports.TableHeader = TableHeader;

_defineProperty(TableHeader, "propTypes", {
  customSortedIcon: _propTypes["default"].element,
  stickyHeader: _propTypes["default"].bool,
  // props from TableContainer
  loading: _propTypes["default"].bool.isRequired,
  tableActions: _propTypes["default"].shape({
    actionsByTypeGet: _propTypes["default"].func.isRequired,
    getFormattedRowData: _propTypes["default"].func.isRequired,
    selectAllRowsHandle: _propTypes["default"].func.isRequired,
    updateTableState: _propTypes["default"].func.isRequired,
    getVisibleColumns: _propTypes["default"].func.isRequired
  }),
  tableData: _propTypes["default"].shape({
    bulkActions: _propTypes["default"].array.isRequired,
    bulkStatusChange: _propTypes["default"].bool.isRequired,
    columns: _propTypes["default"].array.isRequired,
    rowData: _propTypes["default"].array.isRequired,
    idKey: _propTypes["default"].string.isRequired,
    selectEnabled: _propTypes["default"].bool,
    statusOptions: _propTypes["default"].array,
    tableSettings: _propTypes["default"].shape({
      searchTerm: _propTypes["default"].string,
      selectedRows: _propTypes["default"].array,
      sortColumn: _propTypes["default"].string,
      sortDirection: _propTypes["default"].string
    }).isRequired
  })
});

TableHeader.defaultProps = {
  loading: true,
  stickyHeader: true
};
var _default = TableHeader;
exports["default"] = _default;